import { combineReducers } from '../lib/imports';

const allRoutes = {
  onboarding: {
    id: 'onboarding',
    path: '/onboarding',
    label: 'Onboarding',
    hideInNav: true,
    displaySettings: {
      showClose: true,
      showLogo: true,
      showPrefix: false,
      showNavLinks: false,
      showFooter: false,
    },
  },
  playNow: {
    id: 'playNow',
    path: '/',
    label: 'Play Now',
    exclude: true,
    hideInNav: false,
    displaySettings: {
      showClose: true,
      showLogo: true,
      showPrefix: true,
      showNavLinks: true,
      showFooter: true,
    },
  },
  history: {
    id: 'history',
    path: '/history',
    label: 'History',
    hideInNav: false,
    displaySettings: {
      showClose: true,
      showLogo: true,
      showPrefix: true,
      showNavLinks: true,
      showFooter: true,
    },
  },
  leaderboard: {
    id: 'leaderboard',
    path: '/leaderboard',
    label: 'Leaderboard',
    hideInIav: false,
    displaySettings: {
      showClose: true,
      showLogo: true,
      showPrefix: true,
      showNavLinks: true,
      showFooter: true,
    },
  },
  gameInfo: {
    id: 'gameInfo',
    path: '/game-info',
    label: 'Game Info',
    hideInNav: false,
    displaySettings: {
      showClose: true,
      showLogo: true,
      showPrefix: true,
      showNavLinks: true,
      showFooter: true,
    },
  },
};

export const showHeaderMap = ['onboarding', 'playNow', 'gameInfo', 'history', 'leaderboard'];

const allRouteIds = (state = Object.keys(allRoutes)) => state;

const routeById = (state = allRoutes) => state;

const currentRoute = (state = 'onboarding', action) => {
  switch (action.type) {
    case 'SET_CURRENT_ROUTE':
      return action?.resp || state;
    case 'FETCH_QUIZ_DATA_FAILURE':
      return 'playNow';
    default:
      return state;
  }
};

const menuLinkClicked = (state = null, action) => {
  switch (action.type) {
    case 'SET_MENU_LINK_CLICK':
      return action.resp;
    default:
      return state;
  }
};

export default combineReducers({
  allRouteIds,
  routeById,
  currentRoute,
  menuLinkClicked,
});
